// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31KQf","largestCol":"styles_largestCol__alFtl","smallestCol":"styles_smallestCol__2Tc2E"};